import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGojek = function SvgGojek(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM8 17.29a9.372 9.372 0 0 1 .63-3.424 9.264 9.264 0 0 1 1.992-3.129 8.97 8.97 0 0 1 2.541-1.853 8.635 8.635 0 0 1 2.492-.78 8.848 8.848 0 0 1 1.596-.1 8.683 8.683 0 0 1 3.141.68 8.957 8.957 0 0 1 2.97 2.037 9.177 9.177 0 0 1 1.683 2.402 9.34 9.34 0 0 1 .905 3.194c.182 1.858-.132 3.622-.97 5.278a9.118 9.118 0 0 1-2.713 3.229 9.02 9.02 0 0 1-1.77 1.032c-.78.344-1.648.05-2.084-.655-.55-.891-.21-2.022.643-2.474.065-.034.131-.065.197-.095l.13-.06a5.666 5.666 0 0 0 2.283-2.01 5.805 5.805 0 0 0 .965-3.038 5.87 5.87 0 0 0-.204-1.817c-.56-2.043-2.152-3.608-4.155-4.09a5.313 5.313 0 0 0-1.718-.13 5.477 5.477 0 0 0-3.46 1.604 5.789 5.789 0 0 0-1.6 2.915 5.85 5.85 0 0 0-.095 1.986 5.81 5.81 0 0 0 1.694 3.503 5.4 5.4 0 0 0 1.679 1.148c.401.175.708.453.904.858.487 1.01-.093 2.239-1.164 2.463a1.643 1.643 0 0 1-1.027-.114 9.105 9.105 0 0 1-2.675-1.813 9.189 9.189 0 0 1-1.938-2.741 9.273 9.273 0 0 1-.79-2.74C8.028 18.136 8 17.714 8 17.29Zm9.002-3.371c1.82-.022 3.336 1.576 3.314 3.49-.023 1.87-1.506 3.415-3.32 3.413-1.839-.002-3.323-1.555-3.312-3.485.012-1.97 1.587-3.448 3.318-3.419Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgGojek;